import cookie from 'cookie-machine';
import {userRoleMap} from "./UserConstants";


const jwt_decode = require('jwt-decode');

let globalAuthState = null;

export function setGlobalAuth(authState) {
    globalAuthState = authState;
}

export function isCreatorOrAdministrator() {
    return hasRoles([userRoleMap['Creator'], userRoleMap['Admin']]);
}

// FOR IPS FUNCTIONS/////////////////////
export function isIPSDataCreatorOrAdministrator() {
    return hasRoles([userRoleMap['DTCreator'], userRoleMap['Admin']]);
}
export function isIPSAdministrator() {
    return hasRoles([userRoleMap['Admin']]);
}
export function isIPSCreator() {
    return hasRoles([userRoleMap['DTCreator']]);
}
export function isIPSChecklistCreator() {
    return hasRoles([userRoleMap['Admin']]);
}

export function isIPSDataViewOnly() {
    return  hasRoles([userRoleMap['ViewOnly']]);;
}
export function isIPSExternalContributorOrExternalView() {
    return hasRoles([userRoleMap['External'],userRoleMap['ExternalViewOnly'], userRoleMap['External_aep'],userRoleMap['ExternalViewOnly_aep']]);
}
/////////////////////////////////////////////

//For FMP Functions
export function isFMPCreatorOrAdministrator() {
    return hasRoles([userRoleMap['FMPCreator'], userRoleMap['Admin']]);
}
export function isAdministrator() {
    return hasRoles([userRoleMap['Admin']]);
}

export function isCreatorOrAdministratorOrInternalContributor() {
    return hasRoles([userRoleMap['Creator'], userRoleMap['Admin'], userRoleMap['Internal']]);
}

export function isViewOnly() {
    return hasRoles([userRoleMap['ViewOnly']]);
}


export function isViewOnlyOrExternalView() {
    return hasRoles([userRoleMap['ViewOnly'],userRoleMap['ExternalViewOnly'],userRoleMap['DTCreator'], userRoleMap['ExternalViewOnly_aep']]);
}


export function isAdministratorOrInternalContributor() {
    return hasRoles( [userRoleMap['Admin'],userRoleMap['Internal']]);
}

export function isExternalContributorOrExternalView() {
    return hasRoles([userRoleMap['External'],userRoleMap['ExternalViewOnly'], userRoleMap['ExternalViewOnly_aep'], userRoleMap['External_aep']]);
}
export function isExternalContributor() {
    return hasRoles([userRoleMap['External'], userRoleMap['External_aep']]);
}
export function isExternalView() {
    return hasRoles([userRoleMap['ExternalViewOnly'], userRoleMap['ExternalViewOnly_aep']]);
}

export function userHasRoles() {
    return hasRoles(Object.values(userRoleMap));
}

function hasRoles(validRoles) {
    let isValid = false;
    getRolesArray().forEach(role => {
        if (validRoles.includes(role)) {
            isValid = true;
        }
    })
    return isValid;
}


/**
* @param {Object} authState
*/
export function getRolesArray() {
     let retVal = [];

    if (globalAuthState && globalAuthState.isAuthenticated) {
        const accessTokenClaims = globalAuthState.accessToken?.claims;
        const idTokenClaims = globalAuthState.idToken?.claims;
        const scopeData = accessTokenClaims?.scope_data;
        if (scopeData && Array.isArray(scopeData)) {
            retVal = scopeData.map(item => item.id);
        } 
        else if (idTokenClaims?.groups) {
            retVal = Array.isArray(idTokenClaims.groups) ? idTokenClaims.groups : [idTokenClaims.groups];
        }
    }
    return retVal;
}